// extracted by mini-css-extract-plugin
export default {"app":"bootstrap_app__Uwni1"};